module.exports = __webpack_public_path__ + "img/reason_1.8e5e567d.png";